import {useState, useEffect}  from 'react';
import NormalIcon from '../StockItems/NormalIcon';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import * as ServerComms from '../utilities/ServerComms';

function App(props) {

  var width = props.width;
  var setTempAddr = props.setTempAddr;
  var clickBack = props.clickBack;
  var currentList = props.currentList;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var userID = props.userID;



  const [contractDeploymentsOfAChain, setContractDeploymentsOfAChain] = useState([]);

  var chainId;
  if (currentList){
    chainId = +CoreFns.relevantChainId(currentList);
  }

  function postOnceOffKey(response){
    setContractDeploymentsOfAChain(response.v);
  }

  function getContractDeploymentsOfAChain(chainId){
      ServerComms.fetchSomething({u:'getContractDeploymentsOfAChain', chainId:chainId, sessionID, signKey, userID}, postOnceOffKey);
  }

  useEffect(()=>{
    getContractDeploymentsOfAChain(chainId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    getContractDeploymentsOfAChain(chainId);
  }, [chainId]); 

  if (!currentList){
    return <div></div>
//
  }

  var smartContracts = currentList.sc;
  var scKeys = Object.keys(smartContracts);

  function getAddSetItem(aScKey, item){
    var addSet = smartContracts[aScKey].addSet;
    var addSetKeys = Object.keys(addSet);
    return addSet[addSetKeys[0]][item];
  }

  var extraDivsInputs = contractDeploymentsOfAChain.filter((aContract, index)=>{
    for (var i = 0; i < scKeys.length; i++){
      var aScKey = scKeys[i];
      var currAddress = getAddSetItem(aScKey, 'addr');
      if (currAddress === aContract.v[1].v){
        return false;
      }
    }
    return true;
  });
  function clickTempAddr(a){
    return function(e){
      setTempAddr(a);
      clickBack();
    }
  }

  function hideContractDeployment(contractDeploymentID){
    return function(e){      
      ServerComms.fetchSomething({u:'hideContractDeploymentsOfAChain', contractDeploymentID, chainId, sessionID, signKey, userID}, postOnceOffKey);
    }

  }

  var extraDivs = extraDivsInputs.map((aContract, index)=>{
    return <div className='row mb-4' key={index}>
    <div className='col-md-12 text-center' >
      {aContract.v[2].v} ({aContract.v[3].v}) {StyleFunctions.shortenName(aContract.v[1].v)}
      <NormalIcon icon='material-symbols:add' title='Select' height='30px' onClick = {clickTempAddr(aContract.v[1].v)} />
      <NormalIcon icon='clarity:eye-hide-solid' title='Remove' height='30px' onClick = {hideContractDeployment(aContract.v[0].v)} />
     </div>
  </div>
  })

  if (!extraDivs){
    extraDivs = 'No Smart Contracts of this Chain on Cues.sg';
  }

  return <div style={{padding:'10px', paddingTop:'5px', width}}>{extraDivs}
    </div>
//  
}

export default App;
